import { attr, belongsTo } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type { CentralMappingCategory } from 'lumen/models';
import CentralMappingMappingEntry from 'lumen/models/central-mapping/mapping-entry';

// True = Yes
// False = No
// Null = Unmapped
// Note: don't define as `@attr('boolean')` otherwise Ember Data will convert `null` values to `false`.
export type BarBased = boolean | null;

export default class CentralMappingMappingEntryMarketSegment extends CentralMappingMappingEntry {
  // @ts-expect-error: Class inheritance
  [Type] = 'central-mapping/mapping-entry-market-segment' as const;

  // The category chosen by backends auto-mapping algorithm. Can not be adjusted by the user.

  @belongsTo('central-mapping/category', { async: false, inverse: null })
  declare autoCategory: CentralMappingCategory | null;

  @attr() declare autoBarBased: BarBased;
  @attr() declare userBarBased: BarBased;

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get barBased() {
    const { userBarBased, autoBarBased } = this;

    return userBarBased ?? autoBarBased;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get category() {
    const { userCategory, autoCategory } = this;

    return userCategory ?? autoCategory;
  }

  get isAutomapped(): boolean {
    return Boolean(!this.userCategory && this.autoCategory);
  }

  get isBarBasedAutomapped(): boolean {
    return Boolean(!this.userBarBased && this.autoBarBased);
  }
}
